import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Dashboard from "@/pages/Dashboard";
import MarketDetail from "@/pages/MarketDetail";
import Watchlist from "@/pages/Watchlist";
import Settings from "@/pages/Settings";
import Alerts from "@/pages/Alerts";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import EdgeLeaderboard from "@/pages/EdgeLeaderboard";
import AIAccuracy from "@/pages/AIAccuracy";
import About from "@/pages/About";
import { AuthProvider } from "@/auth/AuthProvider";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/market/:id" element={<MarketDetail />} />
      <Route path="/event/:id" element={<EventDetail />} />
      <Route path="/events" element={<Events />} />
      <Route path="/edge" element={<EdgeLeaderboard />} />
      <Route path="/accuracy" element={<AIAccuracy />} />
      <Route path="/about" element={<About />} />
      <Route path="/watchlist" element={<Watchlist />} />
      <Route path="/alerts" element={<Alerts />} />
      <Route path="/settings" element={<Settings />} />
      {/* /login and /auth/callback removed — wallet-only sign-in via /about */}
      <Route path="/login" element={<Navigate to="/about" replace />} />
      <Route path="/auth/callback" element={<Navigate to="/about" replace />} />
    </Routes>
  );
}

function App() {
  // Register service worker (PWA install + push notifications + periodic sync)
  // and listen for SW messages (e.g. notification clicks reuse the open tab).
  React.useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    const register = () => {
      navigator.serviceWorker
        .register("/sw.js")
        .catch((err) => console.warn("SW register failed:", err));
    };
    if (document.readyState === "complete") register();
    else window.addEventListener("load", register, { once: true });

    const onMsg = (event) => {
      const data = event.data || {};
      if (data.type === "mfsmai_navigate" && data.url) {
        window.location.assign(data.url);
      }
    };
    navigator.serviceWorker.addEventListener("message", onMsg);
    return () => navigator.serviceWorker.removeEventListener("message", onMsg);
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster theme="dark" position="bottom-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
